import './App.css';
import Home from './Pages/Home';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Forsale from './Pages/Forsale';
import Searchlist from './Pages/Searchlist';
import ValuServices from './Pages/Services/ValuServices';
import TranServices from './Pages/Services/TranServices';
import AdServices from './Pages/Services/AdServices';
import OurStory from './Pages/OurStory';
import Community from './Pages/Community';
import MetTeam from './Pages/MetTeam';
import Jointeam from './Pages/Jointeam';
import Contact from './Pages/Contact'
import News from './Pages/News'
import Slides from './Pages/Slides'


function App() {
  return (
    <>
      <Router>
        <Routes>
          <Route path='/' element={<Home />} />
          <Route path='/Search' element={<Searchlist />} />
          <Route path='/Forsale' element={<Forsale />} />
          <Route path='/OurServices' element={<ValuServices />} />
          <Route path='/TranServices' element={<TranServices />} />
          <Route path='/AdServices' element={<AdServices />} />
          <Route path='/OurStory' element={<OurStory/>}/>
          <Route path='/Community' element={<Community/>}/>
          <Route path='/MetTeam' element={<MetTeam/>}/>
          <Route path='/Jointeam' element={<Jointeam/>}/>
          <Route path='/Contact' element={<Contact/>}/>
          <Route path='/New' element={<News/>}/>
          <Route path='/Slider' element={<Slides/>}/>
        </Routes>
      </Router>
    </>
  );
}

export default App;
